import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=407e5f1d&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=js&"
export * from "./Classroom.vue?vue&type=script&lang=js&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=407e5f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e5f1d",
  null
  
)

export default component.exports